<template>
    <div v-if="isKp" class="login-wrap" v-loading="loginLoading">
        <v-header></v-header>
        <div class="login-top" :class="{'bg-white':!isKp}">
            <ContentLeft v-if="isKp"></ContentLeft>
            <div v-else class="client-left-container">
                <div class="imglogo">
                    <img src="@/assets/img/clara.png" />
                </div>
            </div>
            
            <div class="client-content border-normal" :style="{width:!isKp?'80%':'70%'}">
                <el-row class="search">
                    <el-form inline size="medium">
                        <div class="mb-10">
                            <GuidanceTooltip
                            :size='20'
                            :content="$t('businesshome_tip')"
                            :jumpLink="$t('businesshome_tip_link')"
                            v-show="getUser.userType == '1'"
                            ></GuidanceTooltip>
                            {{$t('please_select_visible_site')}}
                        </div>
                        
                        <el-form-item>
                            <el-select
                                v-model="filterSite"
                                collapse-tags
                                multiple
                                class="select-cls"
                                clearable
                                @visible-change="
                                    (e) => {
                                        !e ? saveSiteFilter() : ''
                                    }
                                "
                                @clear="saveSiteFilter"
                                @remove-tag="saveSiteFilter"
                                @change="onSelectChange"
                            >
                                <el-option v-for="(v, k) in siteOptions" :key="k" :value="v.siteId" :label="v.siteName">
                                    <span style="float: right; font-weight: 700; font-size: 14px" v-if="[-1, -2].includes(v.siteId)">{{
                                        v.siteName
                                    }}</span>
                                    <span style="float: left; font-size: 14px" v-else>{{ v.siteName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                :placeholder="$t('ENTER_SEARCH_CONTENT')"
                                v-model="searchKey"
                                maxlength="100"
                                @keyup.enter.native="searchSite"
                                class="client-search"
                            >
                                <el-button @click="searchSite" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <ContentTopRight :isKp="isKp"></ContentTopRight>
                </el-row>
                <i v-if="hasPrev" @click="prev" class="el-icon-arrow-left switch left"></i>
                <i v-if="hasNext" @click="next" class="el-icon-arrow-right switch right"></i>
                <el-row class="client-item" >
                    <div
                        :class="[
                            'item',
                            item.rollForWardFlag ? 'site-rollFordWard' : '',
                            item.isSiteAdmin ? 'site-isAdmin' : 'not-site-isAdmin',
                            !isKp?'client-width-client':''
                        ]"
                        v-for="(item, index) in siteList"
                        :key="item.siteId"
                    >
                        <!-- 测试站点水印 -->
                        <img v-if="item.ifTestSite" src="@/assets/img/demo_site.svg" class="test-site-watermark">
                        </img>
                        <div v-if="getUser.userType === '2'" class="siteItem">
                            <!--<div class="site-status" :class="item.siteUsageStatus">
                {{item.siteUsageStatus}}
            </div>-->
                            <div class="whole">
                                <div class="tName">
                                    <span>{{ item.clientName }}</span>
                                </div>
                                <div @click="goToClient(item)" class="bName">
                                    <span>{{ item.siteName }}</span>
                                </div>
                            </div>
                            <div  class="set-icon flex">
                                <img :src="!item.ifPin?notPinIcon:pinedIcon" class="pin-normal mr-10" @click="updatePinStatus(item)" />
                                <img :src="!item.ifPin?notPinIconHover:pinedIconHover" class="pin-hover mr-10" @click="updatePinStatus(item)" />
                                
                                <template v-if="item.isSiteAdmin">
                                    <img
                                        v-if="item.rollForWardFlag"
                                        src="@/assets/img/icon-setting3.svg"
                                        class="item-i"
                                        @click="goToSetting(item)"
                                    />
                                    <img v-else src="@/assets/img/icon-setting.svg" class="item-i" @click="goToSetting(item)" />
                                    <img src="@/assets/img/icon-setting2.svg" class="item-i2" @click="goToSetting(item)" />
                                </template>   
                            </div>
                            
                        </div>
                        <el-popover
                            v-else
                            style="display: inline-block; width: 100%; height: 100%"
                            placement="bottom"
                            popper-class="scale-popper-cls"
                            trigger="hover"
                            :open-delay="1500"
                        >
                            <div class="engagement-info">
                                <div class="engagement-item engagement-item-sitecode">
                                    {{ $t('site_code') }}: <span class="value">{{ item.siteCode }}</span>
                                </div>
                                <div class="engagement-item">
                                    <el-popover
                                        trigger="hover"
                                        :open-delay="1500"
                                        placement="right"
                                        popper-class="engagement-info-popover"
                                        :content="$t('team_member')"
                                    >
                                        <div class="el-col-auto margin-right-30" slot="reference">
                                            <div class="el-col-auto engagement-item-icon">
                                                <img src="@/assets/img/icon-kpuser.svg" width="100%" class="kp-user" />
                                            </div>
                                            <span class="engagement-item-value">{{ item.statisticData?item.statisticData.kpTeamMemberCount:null }}</span>
                                            <span class="engagement-item-unit"> ppl</span>
                                        </div>
                                    </el-popover>
                                    <el-popover
                                        trigger="hover"
                                        :open-delay="1500"
                                        placement="right"
                                        popper-class="engagement-info-popover"
                                        :content="$t('client_user')"
                                    >
                                        <div class="el-col-auto" slot="reference">
                                            <div class="el-col-auto engagement-item-icon">
                                                <img src="@/assets/img/icon-clientuser.svg" width="100%" class="client-user" />
                                            </div>
                                            <span class="engagement-item-value client">{{
                                                item.statisticData ? item.statisticData.invitedClientUserCount : ''
                                            }}</span>
                                            <span class="engagement-item-unit"> ppl</span>
                                        </div>
                                    </el-popover>
                                </div>
                                <div class="engagement-item">
                                    <el-popover
                                        trigger="hover"
                                        :open-delay="800"
                                        placement="right"
                                        popper-class="engagement-info-popover"
                                        :content="$t('file_upload_size')"
                                    >
                                        <div class="el-col-auto margin-right-30" slot="reference">
                                            <div class="el-col-auto engagement-item-icon">
                                                <img src="@/assets/img/icon-upload-green.svg" width="100%" class="green-bdg" />
                                            </div>
                                            <span class="engagement-item-value green">{{ item.statisticData.existFileTotalSize }}</span>
                                            <!--<span class="engagement-item-unit"> GB</span>-->
                                        </div>
                                    </el-popover>
                                    <el-popover
                                        trigger="hover"
                                        :open-delay="1500"
                                        placement="right"
                                        popper-class="engagement-info-popover"
                                        :content="$t('file_upload_number')"
                                    >
                                        <div class="el-col-auto" slot="reference">
                                            <div class="el-col-auto engagement-item-icon">
                                                <img src="@/assets/img/icon-upload-green.svg" width="100%" class="green-bdg" />
                                            </div>
                                            <span class="engagement-item-value green">{{ item.statisticData.existFileCount }}</span>
                                            <span class="engagement-item-unit"> PCS</span>
                                        </div>
                                    </el-popover>
                                </div>
                                <div class="engagement-item no-border">
                                    <el-popover
                                        trigger="hover"
                                        :open-delay="1500"
                                        placement="right"
                                        popper-class="engagement-info-popover"
                                        :content="$t('file_download_size')"
                                    >
                                        <div class="el-col-auto margin-right-30" slot="reference">
                                            <div class="el-col-auto engagement-item-icon">
                                                <img src="@/assets/img/icon-download-blue.svg" width="100%" class="kp-user" />
                                            </div>
                                            <span class="engagement-item-value">{{ item.statisticData.downloadFileTotalSize }}</span>
                                            <!--<span class="engagement-item-unit"> GB</span>-->
                                        </div>
                                    </el-popover>
                                    <el-popover
                                        trigger="hover"
                                        :open-delay="1500"
                                        placement="right"
                                        popper-class="engagement-info-popover"
                                        :content="$t('file_download_number')"
                                    >
                                        <div class="el-col-auto" slot="reference">
                                            <div class="el-col-auto engagement-item-icon">
                                                <img src="@/assets/img/icon-download-blue.svg" width="100%" class="kp-user" />
                                            </div>
                                            <span class="engagement-item-value">{{ item.statisticData.downloadFileCount }}</span>
                                            <span class="engagement-item-unit"> PCS / </span>
                                            <span class="engagement-item-value">{{ item.statisticData.downloadCount }}</span>
                                            <span class="engagement-item-unit"> Times</span>
                                        </div>
                                    </el-popover>
                                </div>
                            </div>
                            <div slot="reference" class="siteItem">
                                <div class="site-status" :class="[item.siteUsageStatus, item.ifTestSite ? 'test-flag' : '']">
                                    {{ item.ifTestSite ? $t('demo_site') : $t(`businesshome_codestatus_${item.siteUsageStatus}`) }}
                                </div>
                                <div class="whole">
                                    <div class="tName">
                                        <span>{{ item.clientName }}</span>
                                    </div>
                                    <div @click="goToClient(item)" class="bName">
                                        <span>{{ item.siteName }}</span>
                                    </div>
                                </div>
                                <div  class="set-icon flex">
                                    <img :src="!item.ifPin?notPinIcon:pinedIcon" class="pin-normal mr-10" @click="updatePinStatus(item)" />
                                    <img :src="!item.ifPin?notPinIconHover:pinedIconHover" class="pin-hover mr-10" @click="updatePinStatus(item)" />
                                    <template v-if="item.isSiteAdmin">
                                        <img
                                            v-if="item.rollForWardFlag"
                                            src="@/assets/img/icon-setting3.svg"
                                            class="item-i"
                                            @click="goToSetting(item)"
                                        />
                                        <img v-else src="@/assets/img/icon-setting.svg" class="item-i" @click="goToSetting(item)" />
                                        <img src="@/assets/img/icon-setting2.svg" class="item-i2" @click="goToSetting(item)" />
                                    </template>   
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div v-for="index of pagination.pageSize - siteList.length" :key="index" class="item item-empty" :class="{'client-width-client':!isKp}"></div>
                </el-row>
            </div>
        </div>
        <v-bottom></v-bottom>
    </div>
    <ClientUserWrap v-else :site-ids="propsFilterSite"></ClientUserWrap>
</template>
<script>
import API from '@/api'
import VBottom from '@/components/common/Bottom.vue'
import VHeader from '@/components/common/Header.vue'
import { mapGetters } from 'vuex'
import { UserInput, loading } from '@/utils'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'
import ContentLeft from './components/ContentLeft.vue'
import ContentTopRight from './components/ContentTopRight.vue'
import ClientUserWrap from './components/ClientUserWrap/index.vue'

export default {
    name: 'business-home',
    data() {
        return {
            user: '',
            loginLoading: false,
            siteList: [],
            searchKey: '',
            propsFilterSite: '', // dropDown接口获取所有站点的站点id列表
            filterSite: '',
            pagination: {
                pageNum: 1,
                pageSize: 15,
                total: 0
            },
            siteOptions: [],
            codeTypeMap: {
                0: this.$t('site_code_type_long_master'),
                1: this.$t('site_code_type_long_sub'),
                2: this.$t('site_code_type_long_opp'),
                3: this.$t('site_code_type_long_bd')
            },
            statusMap: {
                true: this.$t('COMMON_YES'),
                false: this.$t('COMMON_NO')
            },
            visible: true,
            notPinIcon:require(`@/assets/img/icon-pin.svg`),
            pinedIcon:require(`@/assets/img/icon-pin-fill.svg`),
            notPinIconHover:require(`@/assets/img/icon-pin-hover.svg`),
            pinedIconHover:require(`@/assets/img/icon-pin-fill-hover.svg`),
            

        }
    },
    methods: {
        async updatePinStatus(item) {
            const { code }= await API.businessHome.updatePinStatus({
                "siteId": item.siteId,
                "userId": this.getUser.userId,
                "ifPin": !item.ifPin  
            })
            if(code === '1'){
                item.ifPin = !item.ifPin  
                this.getSite()
            }

        },
        onSelectChange(e) {
            this.filterSite = e
            if (e.find((v) => v == -1)) {
                this.onSiteSelectAllClick()
                this.filterSite = this.filterSite.filter((v) => ![-1, -2].includes(v))
            } else if (e.find((v) => v == -2)) {
                this.onSiteUnSelectAllClick()
                this.filterSite = this.filterSite.filter((v) => ![-1, -2].includes(v))
            }
        },
        onSiteSelectAllClick() {
            this.filterSite = this.siteOptions.map((v) => v.siteId)
            this.saveSiteFilter()
        },
        onSiteUnSelectAllClick() {
            this.filterSite = []
            this.saveSiteFilter()
        },
        getSiteOptions() {
            this.loginLoading = true
            API.system.queryAllSites().then((res) => {
                if (res.code === '1') {
                    if (this.getUser.userType === '2' && res.data.length === 1) {
                        // 客户端重做了，有自己的逻辑
                        // this.goToClient(res.data[0])
                    }
                    this.siteOptions = [
                        { siteId: -1, siteName: `[${this.$t('select_all')}]` },
                        { siteId: -2, siteName: `[${this.$t('unselect_all')}]` },
                        ...res.data
                    ]
                    this.filterSite = res.data.filter((v) => v.selected).map((v) => v.siteId)
                    this.propsFilterSite = res.data.map((v) => v.siteId).join(',')
                    this.getSite()
                    window.reloadPageByI18n = (i18n) => {
                        this.siteOptions = [
                            { siteId: -1, siteName: `[${this.$t('select_all')}]` },
                            { siteId: -2, siteName: `[${this.$t('unselect_all')}]` },
                            ...res.data
                        ]
                    }
                }
            })
            this.loginLoading = false
        },
        saveSiteFilter(e) {
            API.businessHome.saveQueryParam({
                siteIds: this.filterSite.join(',')
            })
            this.getSite()
        },
        prev() {
            if (this.pagination.pageNum > 1) {
                this.pagination.pageNum = this.pagination.pageNum - 1
                this.getSite()
            }
        },
        next() {
            this.pagination.pageNum = this.pagination.pageNum + 1
            this.getSite()
        },
        async goToSetting(data) {
            sessionStorage.setItem('siteClassification', data.siteClassification)
            await this.queryMenuList(data.siteId)
            this.$store.commit('common/setSite', data)
            this.$router.push({
                path: '/settingHome'
            })
        },
        async goToClient(data) {
            sessionStorage.setItem('siteClassification', data.siteClassification)
            if (this.getUser.userType == '2' && data.invalidIpFlag) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: this.$t('USER_IP_NOTAVALIABLE_2'),
                    type: 'error'
                })
                return
            }
            await this.queryMenuList(data.siteId)
            this.$store.commit('common/setSite', data)
            API.businessHome.siteClick({
                "siteId": data.siteId,
	            "userId": this.getUser.userId
            })
            this.$router.push({
                path: '/client',
                query: data
            })
        },
        async queryMenuList(siteId) {
            // API.general.siteTilesGeneral({ siteId: siteId }).then((res) => {
            //     if (res.code === '1') {
            //         const menuCodeList = res.data.siteMenuList.filter((item) => item.checked).map((item) => item.menuCode)
            //         this.$store.commit('common/setShowMenuCodeList', menuCodeList)
            //     }
            // })
            this.getUserSiteAuthorityInfo(siteId)
        },
        // 获取用户载当前站点的权限
        getUserSiteAuthorityInfo(siteId) {
            if (this.getUser.userType === '1') {
                API.businessHome.getUserSiteAuthorityInfo({ siteId }).then((res) => {
                    if (res.code === '1') {
                        this.$store.commit('common/setUserIdentity', res.data)
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            } else {
                API.common.getClientAuthorityInfo({ siteId }).then((res) => {
                    if (res.code === '1') {
                        this.$store.commit('common/setUserIdentity', res.data)
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            }
        },
        searchSite: _.debounce(
            function () {
                this.pagination.pageNum = 1
                if (this.searchKey && !UserInput.reg.test(this.searchKey)) {
                    this.$message.error(this.$t('ILLEGAL_USER_INPUT_01'))
                    return
                }
                this.getSite()
            },
            500,
            {
                leading: true
            }
        ),
        getSite() {
            this.pagination.pageSize = this.isKp?15:20
            const _loading = loading()
            const params = {
                searchContent: this.searchKey,
                siteIds: this.filterSite.join(','),
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize
            }
            _loading.load()
            try {
                API.businessHome.querySite(params).then((res) => {
                if (res.code === '1') {
                    this.siteList = res.data.records || []
                    this.pagination.total = res.data.total
                } else {
                    this.$message.error(this.$t(res.code))
                }
                    _loading.close()
                })
            } catch (e) {
                _loading.close()
            }
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser'
        }),
        hasPrev() {
            const { total, pageSize, pageNum } = this.pagination
            return total > pageSize && pageNum > 1
        },
        hasNext() {
            const { total, pageSize, pageNum } = this.pagination
            return total > pageSize * pageNum
        },
        isKp() {
            return this.getUser.userType === '1'
        },
    },
    async mounted() {
      await this.getSiteOptions()

      if(this.getUser.userType === '2') return
      //AAP接入
      const { engagementCode } = this.$route.query
      if(engagementCode && !['undefined','null'].includes(engagementCode)){
        //获取site信息
        const {code,data} = await API.businessHome.querySiteInfo({
          engagementCode
        })
        if(code === '1'){
          if(data.length>0){
            this.goToClient(data[0])
          }else{
            this.$router.replace({name: 'notSite'});
          }
        }
      }

      

    },
    beforeMount() {},
    components: {
        VBottom,
        VHeader,
        GuidanceTooltip,
        ContentLeft,
        ContentTopRight,
        ClientUserWrap 
    }
}
</script>
<style scoped>
body {
    overflow-y: auto !important;
}

.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
}

.login-top {
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    position: relative;
    width: 100%;
    height: calc(100% - 70px - 46PX);
    background: #f3f3f3;
    padding: 15px;
}


.ms-title img {
    width: 82px;
    height: 34px;
    display: block;
    margin: 0 auto;
    margin-top: 20px;
}

.ms-title label {
    display: block;
    width: 100%;
    text-align: center;
    font-family: 'KPMG Light', 'KPMG';
    font-size: 36px;
    color: #00338d;
    margin-top: 10px;
}

.client-content {
    width: 70%;
    height: 100%;
    background: #ffffff;
    padding: 20px 24px 20px 24px;
    position: relative;
    box-shadow: 1px -2px 12px rgba(215, 215, 215, 0.5)
}

.search {
    /* height: 100px; */
    font-size: 16px;
    color: #333333;
    display: flex;
   justify-content: space-between
}
::v-deep .search.el-row::before, .el-row::after{
    display: none;
}

.search ::v-deep .el-form-item__label,
.search ::v-deep .el-form .el-form-item .el-form-item__content .el-input .el-input__inner {
    font-size: 14px;
}

.select-cls {
    width: 360px;
    /* margin-right: 15px; */
}

.select-cls ::v-deep.el-tag.el-tag--info {
    font-size: 14px;
}

.client-search {
    width: 360px;
    font-size: 21px;
}

.client-search ::v-deep .el-input-group--prepend .el-input__inner,
.client-search ::v-deep .el-input-group__append {
    background-color: #3879eb;
    color: #fff;
    border: 1px solid #3879eb;
}

.client-content .item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: calc((100% - 36px)/3);
    height: calc((100% - 155px) / 5);
    float: left;
    margin-right: 18px;
    margin-bottom: 18px;
    box-sizing: border-box;
    background-color: #f3f7ff;
    border-radius: 8px;
    padding: 20px ;
    overflow: hidden;
}

.client-width-client{
    width: calc(25% - 15px) !important;
    margin-right: 15px !important;
}

.client-content .item:nth-child(3n){
    margin-right: 0;
}

.client-content .item.item-empty {
    background-color: #f6f6f6;
    color: #333333;
}

.client-content .item.site-rollFordWard {
    background-color: #f6f6f6;
}

.client-item {
    text-align: center;
    height: 100%;
    overflow-y: auto;
}

.client-item .left {
    width: calc(100% - 60px);
    height: 100%;
}

.client-item .whole {
    width: calc(100% - 60px);
    margin: auto 0;
}


.tName,
.bName {
    color: #00338d;
    text-align: left;
    font-size: 24px;
    /* height: 45%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: bolder;
}

.bName {
    cursor: pointer;
    font-size: 20px;
    margin-top: 10px;
    font-weight: normal;
}

.bName > span,
.tName > span {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    vertical-align: middle;
}

.client-content .item.site-rollFordWard .tName,
.client-content .item.site-rollFordWard .bName,
.client-content .item.site-rollFordWard .item-i {
    color: #333333;
}

.item-i {
    width: 20px;
    cursor: pointer;
}

.item-i2 {
    width: 20px;
    display: none;
}

.client-content .item:not(.item-empty):hover {
    background: url('~@/assets/img/site_hover_bg.png') center center/100% 100% no-repeat;
}

.client-content .item:hover .bName,
.client-content .item:hover .tName {
    color: #fff;
}

.client-content .item:hover .item-i {
    display: none;
}

.client-content .item:hover .item-i2 {
    display: inline-block;
}

.not-site-isAdmin:hover .item-i2 {
    display: none !important;
}

.switch {
    z-index: 1;
    position: absolute;
    top: 50%;
    font-size: 35px;
    cursor: pointer;
    color: #fff;
    width: 35px;
    height: 70px;
    line-height: 70px;
    background-color: rgba(0, 0, 0, 0.1);
}

.switch.left:hover,
.switch.right:hover {
    background-color: rgba(0, 0, 0, 0.4);
}

.switch.left {
    left: 0;
    text-align: left;
    border-radius: 0 35px 35px 0;
}

.switch.right {
    right: 0;
    text-align: right;
    border-radius: 35px 0 0 35px;
}

.filter-span {
    color: #409eff;
    margin-right: 5px;
}

.filter-span:hover {
    cursor: pointer;
}

::v-deep .el-select__tags .el-tag {
    max-width: 130px;
}

::v-deep .el-select .el-select__tags > span {
    display: flex;
}

/*.engagement-info {*/
/*  font-size: 20px;*/
/*}*/

.engagement-info .value {
    color: rgb(56, 121, 235);
}

::v-deep .el-form--inline .guidance-tooltip-container {
    margin-top: 5px;
    margin-right: 10px;
}

.engagement-info .engagement-item {
    display: flex;
    height: 54px;
    line-height: 54px;
    border-bottom: 1px dashed #e1e4e8;
    font-size: 14px;
}
.engagement-info .engagement-item-sitecode {
    height: 40px;
    padding-bottom: 5px;
}

.no-border {
    border-bottom: none !important;
}

.margin-right-30 {
    margin-right: 30px;
}

.engagement-item-icon {
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 54px;
}

.engagement-item-icon img {
    height: 24px;
    width: 24px;
    padding: 4px;
    border-radius: 5px;
}

.engagement-item-value {
    color: #1e49e2;
    font-family: 'KPMG';
    font-weight: bold;
    font-size: 20px;
}

.client {
    color: #00338d;
}

.green {
    color: #00c0ae;
}

.engagement-item-unit {
    color: #333333;
    font-family: '思源黑体';
    font-size: 14px;
}

.kp-user {
    background-color: rgba(56, 121, 235, 0.1);
}

.client-user {
    background-color: rgba(109, 32, 119, 0.1);
}

.green-bdg {
    background-color: rgba(0, 154, 68, 0.1);
}

.siteItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: 100%;
}

.client-content .item:hover .site-status {
    color: #fff !important;
}

.site-status {
    position: absolute;
    right: 0;
    top: 0;
    padding: 8px;
    border-radius: 0 8px 0 8px;
    font-weight: bold;
}

/* 测试站点右上角颜色 */
.site-status.test-flag {
    background: #fd349c;
    color: #fff;
}
.test-site-watermark {
    height: 80%;
    position: absolute;
    bottom: 10%;
    right: 55px;
}

.Set-up {
    background-color: rgba(30, 73, 226, 0.2);
    color: #1e49e2;
}

.In-use {
    background-color: rgba(0, 192, 174, 0.2);
    color: #00c0ae;
}

.Created {
    background-color: rgba(81, 13, 188, 0.2);
    color: #510dbc;
}

.Closed {
    background-color: rgba(22, 36, 59, 0.2);
    /*background-color: #CCCED2;*/
    color: #333333;
}

.set-icon {
    position: relative;
    position: absolute;
    right: 10px;
    bottom: 12px;
}

.pin-hover{
    display: none;
    width: 20px;
    cursor: pointer;
}
.pin-normal{
    display: block;
    width: 20px;
    cursor: pointer;
}
.client-content .item:hover .pin-hover {
    display: block;
}
.client-content .item:hover .pin-normal {
    display: none;
}
.client-left-container{
    width: 20%;
}
.imglogo img{
    width:400px;
}
</style>
<style>
.scale-popper-cls {
    /*width: 390px;*/
    width: 20vw;
    padding: 15px;
    /*transform: scale(0.8);*/
    /*-webkit-transform: scale(0.8);*/
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5) !important;
}

.engagement-info-popover {
    line-height: 24px !important;
    padding: 5px 5px !important;
    background-color: #00338d !important;
    color: white !important;
    font-size: 12px !important;
}

.engagement-info-popover .popper__arrow::after {
    border-right-color: #00338d !important;
    border-left-color: #00338d !important;
}
</style>
